export default __webpack_public_path__ + "static/img/logo.b5fdf281.jpeg";